import {
    DDSAPI,
} from './SharedClass'

const outputs = window.AmplifyOutputs

// 画面用Lambda(dds_page_lambda)を呼び出す
// name: Lambda関数名
// payload: Lambda関数に渡すパラメータ
//   functionName: 呼び出す処理名
//   その他: 呼び出す処理毎のパラメータ
export const CallLambda = async (name: string, payload : Object) => {
    const functionName = outputs.custom.dds_page_lambda
    const input = {
        ...{
            "functionName": name,
        },
        ...payload,
    };
    try {
        const response = await DDSAPI.call(functionName, input)
        return response as unknown
    }
    catch (e) {
        throw e
    }
}

// SQL実行用Lambda(exec_sql_lambda)を呼び出す
export const CallLambdaExecSql = async (sql: string, params: (string | number)[]) => {
    const functionName = outputs.custom.exec_sql_lambda

    const input = {
        "sql": sql,
        "params": params,
    };

    try {
        const response = await DDSAPI.call(functionName, input)
        return response
    }
    catch (e) {
        throw e
    }
}

// 案件用カスタマイズ関数
// emode取得用Lambda(get_emode_lambda)を呼び出す
export const CallLambdaGetEmode = async () => {
    const functionName = outputs.custom.get_emode_lambda
    const input = {};
    
    try {
        const response = await DDSAPI.call(functionName, input)
        return response as unknown
    }
    catch (e) {
        throw e
    }   
}

// emodeチェック用Lambda(emode_check_lambda)を呼び出す
export const CallLambdaEmodeCheck = async () => {
    const functionName = outputs.custom.emode_check_lambda
    const input = {};
    try {
        const response = await DDSAPI.call(functionName, input)
        return response as unknown
    }  
    catch (e) {
        throw e
    }
}

// emode解除用Lambda(emode_off_lambda)を呼び出す
export const CallLambdaEmodeOff = async () => {
    const functionName = outputs.custom.emode_off_lambda
    const input = {};
    try {
        const response = await DDSAPI.call(functionName, input)
        return response as unknown
    }
    catch (e) {
        throw e
    }
}